export default "__VITE_ASSET__DtDd5B1q__ 120w, __VITE_ASSET__CJpkpRtq__ 240w, __VITE_ASSET__BEoUrvVi__ 480w, __VITE_ASSET__DsLcspAi__ 512w";